import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, faqLD, SITE_URL } from "@/content/seo";

const TITLE = "Passeios de Barco em Albufeira · Iate Privado · Morningstar";
const DESC =
  "Passeios de barco privados perto de Albufeira no Morningstar — Marina de Vilamoura a 15 minutos. Gruta de Benagil, falésias de Falésia e Galé, cruzeiros pôr do sol e dia inteiro.";
const PATH = "/pt/passeios-de-barco-albufeira";
const URL = `${SITE_URL}${PATH}`;

export const Route = createFileRoute("/pt/passeios-de-barco-albufeira")({
  component: () => (
    <SitePage
      lang="pt"
      heroOverride={{
        eyebrow: "Passeios de Barco em Albufeira · Algarve",
        title: "Passeios de barco em Albufeira a bordo do ",
        titleAccent: "Morningstar.",
        sub: "Curta transferência de Albufeira para a Marina de Vilamoura — grutas de Benagil, falésias de Falésia, Galé e cruzeiros pôr do sol no Algarve central.",
        ctaPrimary: "Ver cruzeiros",
        ctaSecondary: "Planear o meu dia",
      }}
    />
  ),
  head: () =>
    buildHead({
      lang: "pt",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords:
        "passeios de barco Albufeira, aluguer barco Albufeira, charter iate Albufeira, Albufeira Benagil, cruzeiro Algarve Albufeira",
      altPath: { en: "/boat-trips-albufeira", pt: PATH },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Passeios de barco privados a partir de Albufeira",
              description: DESC,
              url: URL,
              itinerary: "Marina de Vilamoura (15 min de Albufeira) → Falésia → Galé → Benagil → mergulho → regresso.",
              durationHours: 5,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Início", path: "/pt" },
              { name: "Passeios de Barco Albufeira", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(faqLD("pt")) },
      ],
    }),
});